import { TextField } from '@mui/material';
import styled from 'styled-components';
import Icons from '../Icons';
import { computeSize } from '../../utils/object-utilities';
import { heightToPixel } from '../../utils/consts';

export const StyledTextField = styled(TextField)`
  width: ${({ $width }) => $width};
  && {
    .MuiOutlinedInput-notchedOutline {
      border-color: var(--inputBorderColor);
      border-width: var(--input-border-width);
    }
    .MuiInputBase-input {
      color: var(--inputFontColor);
    }
    .MuiOutlinedInput-root:hover:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline,
    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: var(--inputFocusedColor);
      border-width: var(--input-border-width);
    }

    .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
      border-color: var(--red);
      border-width: var(--input-border-width);
    }

    .MuiInputLabel-root {
      font-family: var(--app-font) Averta, sans-serif;
      font-size: 13px;
      color: var(--select-label-color);
    }

    .MuiInputBase-root {
      font-family: var(--app-font) Averta, sans-serif;
      border-radius: var(--input-border-radius);
      background-color: var(--inputBgColor);
      padding: 0;

      .MuiInputBase-input {
        box-sizing: border-box;
        height: ${({ $height }) => computeSize($height, heightToPixel, '35px')};
        letter-spacing: 0.5px;
        font-size: 14px;
        padding: 8.5px 16px;
        color: var(--inputBaseColor);
        border-radius: var(--input-border-radius);

        &::placeholder {
          color: var(--legacy-input-placeholder-color, currentColor);
        }
      }

      .Mui-disabled {
        color: var(--inputDisabledBaseColor);
        -webkit-text-fill-color: unset;
      }
    }
    .MuiInputBase-root.Mui-disabled {
      background-color: var(--inputDisabledBgColor);
    }
    .MuiInputBase-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
      border-color: var(--inputDisabledBorderColor);
    }
    .MuiFormHelperText-root {
      position: absolute;
      bottom: -18px;
      right: 0;
      margin-right: 0;
      margin-top: unset;
      color: var(--red);
      letter-spacing: 0.5px;
      line-height: 1.42;
    }
  }
`;

export const TextFieldWrapper = styled.div.attrs({ className: 'dsc-textInputWrapper' })`
  position: relative;
`;

export const LoadingIcon = styled(Icons.InProgress)`
  position: absolute;
  top: -8px;
  right: -8px;
`;

export const UploadIconWrapper = styled.div.attrs({ className: 'dsc-uploadIconController' })`
  display: flex;
  align-items: center;
  height: ${({ $height }) => computeSize($height, heightToPixel, '36px')};
  width: ${({ $width }) => $width};
  position: relative;
  .dsc-hidden-file-input,
  input {
    display: none;
  }
`;

export const FileNameWrapper = styled.div`
  background-color: var(--inputDisabledBgColor);
  box-sizing: border-box;
  margin-left: 8px;
  padding: 5px;
  width: 100%;
  height: 100%;
  border-radius: var(--input-border-radius);
  font-size: 12px;
  color: ${({ $empty }) => ($empty ? 'var(--input-secondary-text-color)' : 'var(--select-text-color)')};
  align-content: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
